import {useEffect, useState} from 'react';
import {useDebounce} from '@wordpress/compose';

/**
 * Taken verbatim from the Gutenberg source code.
 *
 * @todo Switch to @wordpress/compose when minimum WP version is 6.5
 *
 * @link https://developer.wordpress.org/block-editor/reference-guides/packages/packages-compose/#usedebouncedinput
 */
export default function useDebouncedInput( defaultValue = '' ): [ string, ( value: string ) => void, string ] {
	const [ input, setInput ] = useState( defaultValue );
	const [ debouncedInput, setDebouncedState ] = useState( defaultValue );

	const setDebouncedInput = useDebounce( setDebouncedState, 500 );

	useEffect( () => {
		setDebouncedInput( input );
	}, [ input, setDebouncedInput ] );

	return [ input, setInput, debouncedInput ];
}
